import { TableColumnsType } from 'antd';
import TableComponent from 'components/Table/TableComponent';
import usePagination from 'hooks/usePagination';
import Content from 'layouts/Content';
import { forwardRef, useImperativeHandle, useMemo } from 'react';
import { formatCurrency } from 'utils/constants/functions';
import { HocChangePagination } from 'utils/HocChangePagination';

interface ITableTeamSaleRevenueProps {
  loading?: boolean;
  data: any;
  exportExcel?: (columns: any) => void;
}

const TableTeamSaleRevenue = (
  { data, loading, exportExcel }: ITableTeamSaleRevenueProps,
  ref: any,
) => {
  const { page, page_size } = usePagination();

  const columns: TableColumnsType = useMemo(
    () => [
      {
        width: 50,
        title: 'STT',
        align: 'center',
        render: (_: any, __: any, index: number) =>
          index + 1 + page_size * (page - 1),
      },
      {
        width: 150,
        title: 'Tỉnh/Thành',
        dataIndex: 'city_name',
      },
      {
        width: 120,
        title: 'Mã đội',
        dataIndex: 'team_sales_id',
      },
      {
        width: 150,
        title: 'Mã chuyến',
        dataIndex: 'trip_id',
      },
      {
        width: 150,
        title: 'Mã tuyến',
        dataIndex: 'route_id',
      },
      {
        title: 'Doanh thu công',
        children: [
          {
            type: 'number',
            currency: 'vi-VN',
            width: 150,
            title: 'Kỳ này',
            dataIndex: 'total_process_price_current',
            align: 'right',
            render: (value: any) =>
              value
                ? formatCurrency({
                    value,
                  })
                : '-',
          },
          {
            type: 'number',
            currency: 'vi-VN',
            width: 150,
            title: 'Kế hoạch',
            dataIndex: 'plan_revenue',
            align: 'right',
            render: (value: any) =>
              value
                ? formatCurrency({
                    value,
                  })
                : '-',
          },
          {
            type: 'number',
            currency: 'vi-VN',
            width: 150,
            title: 'Cùng kỳ',
            dataIndex: 'total_process_price_last_year',
            align: 'right',
            render: (value: any) =>
              value
                ? formatCurrency({
                    value,
                  })
                : '-',
          },
          {
            type: 'number',
            currency: 'vi-VN',
            width: 150,
            title: 'Kỳ trước',
            dataIndex: 'total_process_price_last_month',
            align: 'right',
            render: (value: any) =>
              value
                ? formatCurrency({
                    value,
                  })
                : '-',
          },
        ],
      },
      {
        title: 'Tỷ lệ doanh thu công',
        children: [
          {
            width: 150,
            title: 'Kỳ này / Kế hoạch',
            dataIndex: 'percent_current',
            align: 'right',
            render: (value) => value || '-',
          },
          {
            width: 150,
            title: 'Kỳ này / Cùng kỳ',
            dataIndex: 'percent_last_year',
            align: 'right',
            render: (value) => value || '-',
          },
          {
            width: 150,
            title: 'Kỳ này / Kỳ trước',
            dataIndex: 'percent_last_month',
            align: 'right',
            render: (value) => value || '-',
          },
        ],
      },
    ],
    [page, page_size],
  );

  useImperativeHandle(ref, () => ({
    handleExportExcel,
  }));

  const handleExportExcel = () => {
    exportExcel && exportExcel(columns);
  };

  return (
    <Content>
      <TableComponent
        scroll={{ x: 'max-content' }}
        columns={columns}
        dataSource={data.items}
        rowKey={(record) => record?.team_sales_id}
        loading={loading}
        pagination={{
          current: data.pageInfo?.currentPage,
          pageSize: data.pageInfo?.itemsPerPage,
          total: data.pageInfo?.totalItems,
          onChange: HocChangePagination(),
        }}
      />
    </Content>
  );
};

export default forwardRef(TableTeamSaleRevenue);
